import { Component } from '@angular/core';
import {SharedService} from "../../../services/shared/shared.service";
import {EinhornImpressumComponent} from "./einhornkraut/einhorn-impressum.component";
import {TelecuraImpressumComponent} from "./telecura/telecura-impressum.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-impressum',
  imports: [
    EinhornImpressumComponent,
    TelecuraImpressumComponent,
    NgIf
  ],
  templateUrl: './impressum.component.html',
})
export class ImpressumComponent {
  branding: string;
  constructor(private shared: SharedService) {
    console.log(this.shared.branding);
    this.branding = this.shared.branding;
  }
}
